import { graphql } from '../gql';

export const submitAnswerMutation = graphql(`
  mutation submitAnswers(
    $languageCode: String!
    $businessLineId: ID
    $completedFormInputs: [CompletedFormInput]!
    $clientEmail: String
    $clientName: String
    $message: String
    $status: String!
    $currentQuoteUUID: String
    $signature: String
    $referralCode: String
    $additionalInformation: String
    $renewalInProgress: Boolean!
    $producerId: String
    $isPolicystreamApplication: Boolean
    $policystreamPlanId: ID
    $policyStreamRecommendation: PolicyStreamRecommendationInput
    $policystreamPlanPaymentFrequency: String
    $resumeTo: String
    $token: String
    $warnings: String
    $axisStructuredData: AxisStructuredDataInput
  ) {
    createQuote(
      languageCode: $languageCode
      businessLineId: $businessLineId
      completedForms: $completedFormInputs
      clientEmail: $clientEmail
      clientName: $clientName
      message: $message
      status: $status
      uniqueId: $currentQuoteUUID
      signature: $signature
      referralCode: $referralCode
      additionalInformation: $additionalInformation
      renewalInProgress: $renewalInProgress
      producerId: $producerId
      isPolicystreamApplication: $isPolicystreamApplication
      policystreamPlanId: $policystreamPlanId
      policyStreamRecommendation: $policyStreamRecommendation
      policystreamPlanPaymentFrequency: $policystreamPlanPaymentFrequency
      token: $token
      resumeTo: $resumeTo
      warnings: $warnings
      axisStructuredData: $axisStructuredData
    ) {
      taskPool {
        id
      }
    }
  }
`);
// previous returned data
// ok
// quote {
//   id
//   uniqueID
//   status
//   dateAdded
//   friendlyId
//   businessLine {
//     id
//     displayName
//   }
//   structuredData {
//     businessLegalName
//     businessName
//     businessTradeName
//   }
//   premiumProposals {
//     id
//     identifier
//     status
//     insurer {
//       name
//     }
//     policies {
//       ...PolicyFields
//     }
//     notes
//     additionalInformation
//     amountInCents
//   }
//   isPolicystreamApplication
//   policystreamPlan {
//     id
//     insurer {
//       id
//       displayName
//     }
//     premiumMonthlyDollars
//     markdownDetails
//   }
// }
